import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  AutomotiveFleet,
  AutomotiveTelematics,
  AutomotiveCharging,
  AutomotiveCarRental,
  AutomotiveRepair,
  AutomotiveMobility,
} from "../../../../app-constants-updated";
import { Link } from "gatsby";

function Automotiveadvanced() {
  return (
    <section className="automotive_advanced p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={9}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>
              Advanced, <span>Custom-Built Solutions</span> for Complex
              Automotive Needs
            </h2>
            <p>
              Our automotive app development company provides a range of
              cutting-edge solutions tailored to meet the unique demands of the
              automotive industry. From fleet management to electric vehicle
              (EV) integration, our solutions drive efficiency, safety, and
              innovation, addressing the most critical aspects of modern
              automotive operations.
            </p>
          </Col>
        </Row>
        <Row className="mt-3 mt-md-4">
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
            <div className="advanced-box">
              <div className="advanced-flex">
                <div className="advanced-icon">{AutomotiveFleet}</div>
                <div className="advanced-content">
                  <h5>Fleet Optimization Solution</h5>
                </div>
              </div>
              <p>
                A comprehensive system for monitoring and optimizing fleet
                performance in real-time. Our solution tracks vehicle location,
                fuel usage, and maintenance schedules, ensuring that businesses
                operate at peak efficiency while reducing operational costs.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
            <div className="advanced-box">
              <div className="advanced-flex">
                <div className="advanced-icon">{AutomotiveTelematics}</div>
                <div className="advanced-content">
                  <h5>Telematics & Vehicle Diagnostics</h5>
                </div>
              </div>
              <p>
                Our advanced telematics system delivers real-time vehicle
                diagnostics and analytics, offering data on everything from
                engine performance to driving behavior. This solution empowers
                businesses to make data-driven decisions, improving vehicle
                lifespan and reducing downtime.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
            <div className="advanced-box">
              <div className="advanced-flex">
                <div className="advanced-icon">{AutomotiveCharging}</div>
                <div className="advanced-content">
                  <h5>EV Charging Network Management</h5>
                </div>
              </div>
              <p>
                Manage and optimize EV charging infrastructure with our robust
                platform. It enables users to locate charging stations, monitor
                availability, and manage payments seamlessly while ensuring
                efficient energy distribution for charging networks.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-xl-0 mb-4">
            <div className="advanced-box">
              <div className="advanced-flex">
                <div className="advanced-icon">{AutomotiveCarRental}</div>
                <div className="advanced-content">
                  <h5>Car Rental & Leasing Platforms</h5>
                </div>
              </div>
              <p>
                Develop custom car rental and leasing solutions that streamline
                booking, vehicle selection, and payment processes. Our platform
                supports both short-term rentals and long-term leasing
                integrated with user authentication and secure payments.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-md-0 mb-4">
            <div className="advanced-box">
              <div className="advanced-flex">
                <div className="advanced-icon">{AutomotiveRepair}</div>
                <div className="advanced-content">
                  <h5>Predictive Maintenance & Repair Scheduling</h5>
                </div>
              </div>
              <p>
                An intelligent system designed to predict and prevent vehicle
                failures by analyzing usage patterns and vehicle health data.
                Automated maintenance reminders and repair scheduling reduce
                downtime and ensure vehicles are always road-ready.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="advanced-box">
              <div className="advanced-flex">
                <div className="advanced-icon">{AutomotiveMobility}</div>
                <div className="advanced-content">
                  <h5>Mobility-as-a-Service (MaaS) Platforms</h5>
                </div>
              </div>
              <p>
                A scalable, customizable platform offering integrated
                transportation solutions. From ride-sharing to public transport
                integration, this solution enables users to plan, book, and pay
                for multiple mobility options within one app, enhancing urban
                mobility experiences.
              </p>
            </div>
          </Col>
        </Row>
        <Row className="mt-3 mt-md-4">
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="m-auto text-center"
          >
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Build Connected Solutions
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Automotiveadvanced;
